import React, { useEffect, useState } from "react";
import Img from "gatsby-image";
import {
	cartHasShippingProtection,
	getShippingProtectionVariant,
} from "../Cart/shipping-protection";

import "./collar-options.scss";

// TODO: Switch these to React.memo and automatically generate the available sizes.
// TODO: Check if that variant is available.
const harnessSizes = ["S", "M", "L"];

export const HarnessSize = ({ setOption, selectedOptions }) => {
	if (!selectedOptions || !selectedOptions.Size) return null;

	const currentSize = selectedOptions.Size;

	return (
		<div className="collar-options collar-options__full-width">
			{harnessSizes.map((size) => {
				const classes =
					currentSize === size
						? "collar-options__size collar-options__size--active"
						: "collar-options__size";

				return (
					<button
						className={classes}
						key={size}
						data-size={size}
						onClick={() => setOption("Size", size)}
					>
						{size}
					</button>
				);
			})}
		</div>
	);
};

const christmasTreeSizes = ["Medium", "XL"];

export const ChristmasTreeSizes = ({ setOption, selectedOptions }) => {
	if (!selectedOptions || !selectedOptions.Size) return null;

	const currentSize = selectedOptions.Size;

	return (
		<div className="collar-options collar-options__full-width">
			{christmasTreeSizes.map((size) => {
				const classes =
					currentSize === size
						? "collar-options__size collar-options__size--active"
						: "collar-options__size";

				return (
					<button
						className={classes}
						key={size}
						data-size={size}
						onClick={() => setOption("Size", size)}
					>
						{size}
					</button>
				);
			})}
		</div>
	);
};

const chewSizes = ["Medium", "XL"];

export const ChewSize = ({ setOption, selectedOptions }) => {
	if (!selectedOptions || !selectedOptions.Size) return null;

	const currentSize = selectedOptions.Size;

	return (
		<div className="collar-options collar-options__full-width">
			{chewSizes.map((size) => {
				const classes =
					currentSize === size
						? "collar-options__size collar-options__size--active"
						: "collar-options__size";

				return (
					<button
						className={classes}
						key={size}
						data-size={size}
						onClick={() => setOption("Size", size)}
					>
						{size}
					</button>
				);
			})}
		</div>
	);
};

export const TreatSize = (props) => {
	const {
		selectedOptions,
		productVariants,
		product,
		images,
		setSelectedImage,
		setFieldValue,
		treatSizes,
		column = false,
	} = props;

	if (!selectedOptions || !selectedOptions.Size) return null;

	const currentSize = selectedOptions.Size;

	const handleSelection = (selectedID) => {
		const currentVariant = productVariants.find((variant) => {
			return variant.title === selectedID;
		});

		// Change image selected.
		if (selectedID && product?.variants) {
			if (currentVariant?.image?.originalSrc) {
				const currentVariantImageUrl = new URL(
					currentVariant?.image?.originalSrc,
				);

				const imageIndex = images?.findIndex((image) => {
					if (!image.originalSrc) return false;
					const imageUrl = new URL(image.originalSrc);
					return (
						currentVariantImageUrl?.pathname === imageUrl?.pathname
					);
				});

				if (imageIndex !== -1) {
					setSelectedImage(imageIndex);
				}
			}
		}

		// Set value on form.
		if (currentVariant?.id) {
			setFieldValue("id", currentVariant?.id);
		}
	};

	return (
		<div
			className="collar-options collar-options__full-width"
			style={
				column
					? {
							flexDirection: "column",
							gap: "8px",
							paddingRight: "2px",
						}
					: {}
			}
		>
			{treatSizes.map((size) => {
				const classes =
					currentSize === size
						? "collar-options__size collar-options__size--active"
						: "collar-options__size";

				return (
					<button
						className={classes}
						key={size}
						data-size={size}
						style={column ? { borderRadius: "99px" } : {}}
						onClick={() => handleSelection(size)}
					>
						{size}
					</button>
				);
			})}
		</div>
	);
};

const collarSizes = ["S", "M", "L"];

export const CollarSize = ({ setOption, selectedOptions }) => {
	if (!selectedOptions || !selectedOptions.Size) return null;

	const currentSize = selectedOptions.Size;

	return (
		<div className="collar-options collar-options__full-width">
			{collarSizes.map((size) => {
				const classes =
					currentSize === size
						? "collar-options__size collar-options__size--active"
						: "collar-options__size";

				return (
					<button
						className={classes}
						key={size}
						data-size={size}
						onClick={() => setOption("Size", size)}
					>
						{size}
					</button>
				);
			})}
		</div>
	);
};

const collarColors = ["Black", "Turquoise"];

export const CollarColor = ({ setOption, selectedOptions }) => {
	if (!selectedOptions || !selectedOptions.Color) return null;

	const currentColor = selectedOptions.Color;

	return (
		<div className="collar-options collar-options__full-width">
			{collarColors.map((color) => {
				const classes =
					currentColor === color
						? "collar-options__color collar-options__color--active"
						: "collar-options__color";

				return (
					<button
						className={classes}
						key={color}
						data-color={color}
						onClick={() => setOption("Color", color)}
					>
						{color}
					</button>
				);
			})}
		</div>
	);
};

const poopBagHolderColors = ["Black", "Sky Blue"];

export const PoopBagHolderColor = ({ setOption, selectedOptions }) => {
	if (!selectedOptions || !selectedOptions.Color) return null;

	const currentColor = selectedOptions.Color;

	return (
		<div className="collar-options collar-options__full-width">
			{poopBagHolderColors.map((color) => {
				const classes =
					currentColor === color
						? "collar-options__color collar-options__color--active"
						: "collar-options__color";

				return (
					<button
						className={classes}
						key={color}
						data-color={color}
						onClick={() => setOption("Color", color)}
					>
						{color}
					</button>
				);
			})}
		</div>
	);
};

const poopBagBundles = ["1 Box for $7.99", "2 Boxes for $15.99"];

export const PoopBagBundle = ({ setOption, selectedOptions }) => {
	if (!selectedOptions || !selectedOptions.Bundle) return null;

	const currentBundle = selectedOptions.Bundle;

	return (
		<div className="collar-options">
			{poopBagBundles.map((bundle) => {
				const classes =
					currentBundle === bundle
						? "collar-options__bundle collar-options__bundle--active"
						: "collar-options__bundle";

				return (
					<button
						className={classes}
						key={bundle}
						data-color={bundle}
						onClick={() => setOption("Bundle", bundle)}
					>
						{bundle}
					</button>
				);
			})}
		</div>
	);
};

const poopBagColorsOptions = [
	"Black",
	"Sky Blue",
	// 'Light Green',
	// 'Baby Pink',
	// 'Yellow'
];

export const PoopBagColor = ({ setOption, selectedOptions, variants }) => {
	if (!selectedOptions || !selectedOptions.Color) return null;

	const currentColor = selectedOptions.Color;

	return (
		<div className="collar-options">
			{poopBagColorsOptions.map((color) => {
				const currentVariant = variants.find((variant) => {
					return variant.selectedOptions.find(({ name, value }) => {
						return name === "Color" && value === color;
					});
				});

				const classes =
					currentColor === color
						? "collar-options__img collar-options__img--active"
						: "collar-options__img";

				return (
					<button
						className={classes}
						key={color}
						data-color={color}
						onClick={() => setOption("Color", color)}
					>
						<Img
							fluid={
								currentVariant.image.localFile.childImageSharp
									.fluid
							}
							className="collar-options__select-img"
						/>
					</button>
				);
			})}
		</div>
	);
};

const giftCardValues = ["$10.00", "$25.00", "$50.00", "$100.00"];
const auGiftCardValues = ["$25.00", "$50.00", "$100.00"];

export const GiftCardDenominations = ({ setOption, selectedOptions }) => {
	if (!selectedOptions || !selectedOptions.Denominations) return null;

	const domain =
		process.env.GATSBY_MYSHOPIFY_URL || "tearribles.myshopify.com";

	const currentDenomination = selectedOptions.Denominations;
	let values = giftCardValues;

	if (domain === "tearriblesau.myshopify.com") {
		values = auGiftCardValues;
	}

	return (
		<div className="collar-options">
			{values.map((denomination) => {
				const classes =
					currentDenomination === denomination
						? "collar-options__denomination collar-options__denomination--active"
						: "collar-options__denomination";

				return (
					<button
						className={classes}
						key={denomination}
						data-color={denomination}
						onClick={() => setOption("Denominations", denomination)}
					>
						{denomination.split(".")[0]}
					</button>
				);
			})}
		</div>
	);
};

export const GiftCardNote = ({ setFieldValue, values }) => {
	const customAttributes = values?.customAttributes || {};
	const value = customAttributes.Note;

	const onChange = (event) => {
		event.preventDefault();
		const newValue = event.target.value;
		const newAttributes = {
			...customAttributes,
			Note: newValue,
			recipient: {
				name: newValue,
			},
		};
		setFieldValue("customAttributes", newAttributes);
	};

	return (
		<div className="collar-options">
			<input
				onChange={onChange}
				value={value || ""}
				type="text"
				name="Note"
				className="collar-options__input"
				placeholder="Optional"
			/>
		</div>
	);
};

const leashSizes = ["S", "L"];

export const LeashSize = ({ setOption, selectedOptions }) => {
	if (!selectedOptions || !selectedOptions.Size) return null;

	const currentSize = selectedOptions.Size;

	return (
		<div className="collar-options collar-options__full-width">
			{leashSizes.map((size) => {
				const classes =
					currentSize === size
						? "collar-options__size collar-options__size--active"
						: "collar-options__size";

				return (
					<button
						className={classes}
						key={size}
						data-size={size}
						onClick={() => setOption("Size", size)}
					>
						{size}
					</button>
				);
			})}
		</div>
	);
};

const stixCount = ["5 Pack", "10 Pack"];

export const StixCount = ({ setOption, selectedOptions }) => {
	if (!selectedOptions || !selectedOptions.Size) return null;

	const currentCount = selectedOptions.Count;
	const currentSize = selectedOptions.Size;

	if (currentSize === "Thin") {
		if (currentCount !== "5 Pack") {
			setOption("Count", "5 Pack");
		}

		return (
			<div className="collar-options collar-options__full-width">
				<button
					className="collar-options__size collar-options__size--active"
					data-size="5 Pack"
				>
					5 Pack
				</button>
			</div>
		);
	}

	return (
		<div className="collar-options collar-options__full-width">
			{stixCount.map((count) => {
				const classes =
					currentCount === count
						? "collar-options__size collar-options__size--active"
						: "collar-options__size";

				return (
					<button
						className={classes}
						key={count}
						data-size={count}
						onClick={() => setOption("Count", count)}
					>
						{count}
					</button>
				);
			})}
		</div>
	);
};

const stixSizes = ["Thin", "Medium", "Jumbo"];

export const StixSize = ({ setOption, selectedOptions }) => {
	if (!selectedOptions || !selectedOptions.Size) return null;

	const currentSize = selectedOptions.Size;

	return (
		<div className="collar-options collar-options__full-width">
			{stixSizes.map((size) => {
				const classes =
					currentSize === size
						? "collar-options__size collar-options__size--active"
						: "collar-options__size";

				return (
					<button
						className={classes}
						key={size}
						data-size={size}
						onClick={() => {
							setOption("Size", size);
						}}
					>
						{size}
					</button>
				);
			})}
		</div>
	);
};

const leashColors = {
	S: ["Black", "Turquoise"],
	L: ["Black", "Tearribles"],
};

export const LeashColor = ({ setOption, selectedOptions }) => {
	const colors = leashColors[selectedOptions?.Size];
	const currentColor = colors.includes(selectedOptions?.Color)
		? selectedOptions.Color
		: colors[0];

	useEffect(() => {
		if (currentColor !== selectedOptions.Color) {
			setOption("Color", colors[0]);
		}
	}, [currentColor]);

	if (!selectedOptions || !selectedOptions.Color || !selectedOptions.Size)
		return null;

	return (
		<div className="collar-options collar-options__full-width">
			{colors.map((color) => {
				const classes =
					currentColor === color
						? "collar-options__color collar-options__color--active"
						: "collar-options__color";

				return (
					<button
						className={classes}
						key={color}
						data-color={color}
						onClick={() => setOption("Color", color)}
					>
						{color}
					</button>
				);
			})}
		</div>
	);
};

const hiddenParts = ["Body", "Head"];
const hiddenColors = ["Clear"];

export const PartSelect = ({ setOption, selectedOptions, options }) => {
	const colorOptions =
		Array.isArray(options) &&
		options.find((item) => {
			return item.name === "Color";
		});

	const colors =
		colorOptions?.values.filter((item) => !hiddenColors.includes(item)) ||
		[];

	const [selectedColor, setSelectedColor] = useState(colors[0]);
	const currentColor =
		colors?.includes(selectedOptions?.Color) && selectedOptions.Color;

	const partsOption =
		Array.isArray(options) &&
		options.find((item) => {
			return item.name === "Part";
		});

	if (!partsOption || !Array.isArray(partsOption.values)) {
		return <></>;
	}

	const parts = partsOption.values.filter(
		(item) => !hiddenParts.includes(item),
	);

	const currentPart = parts.includes(selectedOptions?.Part)
		? selectedOptions.Part
		: parts[0];

	if (!selectedOptions || !selectedOptions.Part) return null;

	return (
		<div className="collar-options">
			{parts.map((part) => {
				const classes =
					currentPart === part
						? "collar-options__color collar-options__color--active"
						: "collar-options__color";

				const onClick =
					part === "Squeaker"
						? async () => {
								setSelectedColor(currentColor);
								await setOption("Part", part);
								setOption("Color", "Clear");
							}
						: async () => {
								if (currentPart === "Squeaker") {
									await setOption("Color", selectedColor);
								}
								await setOption("Part", part);
							};

				return (
					<button
						className={classes}
						key={part}
						data-part={part}
						onClick={onClick}
					>
						{part}
					</button>
				);
			})}
		</div>
	);
};

export const PartsColor = ({ setOption, selectedOptions, options }) => {
	const currentPart = selectedOptions?.Part;

	if (currentPart === "Squeaker") {
		return <p>Clear</p>;
	}

	const partsOption =
		Array.isArray(options) &&
		options.find((item) => {
			return item.name === "Color";
		});

	if (!partsOption || !Array.isArray(partsOption.values)) {
		return <></>;
	}

	const parts = partsOption.values.filter(
		(item) => !hiddenColors.includes(item),
	);

	const currentColor = parts.includes(selectedOptions?.Color)
		? selectedOptions.Color
		: null;

	if (!selectedOptions) return null;

	return (
		<div className="collar-options">
			{parts.map((color) => {
				const classes =
					currentColor === color
						? "collar-options__color collar-options__color--active"
						: "collar-options__color";

				return (
					<button
						className={classes}
						key={color}
						data-part-color={color}
						onClick={() => setOption("Color", color)}
					>
						{color}
					</button>
				);
			})}
		</div>
	);
};

export const ShippingProtectionAmount = (props) => {
	const hasShippingProtection = cartHasShippingProtection(props.cart);

	const product = props?.data?.allShopifyProduct?.edges[0]?.node;
	const cartSubTotal = parseFloat(props.cart?.subtotalPrice?.amount || 0);
	const variant = getShippingProtectionVariant(product, cartSubTotal, null);

	const { setOption, selectedOptions } = props;

	useEffect(() => {
		if (!hasShippingProtection && variant?.selectedOptions?.[0]?.value) {
			setOption("Amount", variant?.selectedOptions?.[0]?.value);
		}
	}, [variant, hasShippingProtection]);

	return null;
};
